import React from 'react';

export default function RegionalTable({ regions, onSelectRegion, selectedRegion }) {
  const sorted = [...regions].sort((a, b) => b.involvement - a.involvement);

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div className="section-title" data-testid="regional-table-title">Regional Overview</div>
      <div className="glass-card" style={{ padding: '0', overflow: 'auto' }}>
        <table className="data-table" data-testid="regional-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Region</th>
              <th className="num">Involvement</th>
              <th className="num">Modified M</th>
              <th className="num">Modified F</th>
              <th className="num">Junior M</th>
              <th className="num">Junior F</th>
              <th className="num">Senior M</th>
              <th className="num">Senior F</th>
              <th className="num">Schools</th>
            </tr>
          </thead>
          <tbody>
            {sorted.map((r, i) => (
              <tr
                key={r.name}
                className="clickable"
                onClick={() => onSelectRegion(r.name)}
                style={selectedRegion === r.name ? { background: 'rgba(11,61,145,0.06)' } : {}}
                data-testid={`region-row-${r.name.toLowerCase().replace(/\s/g, '-')}`}
              >
                <td style={{ fontWeight: 600, color: 'var(--text-muted)' }}>{i + 1}</td>
                <td style={{ fontWeight: 600 }}>{r.name}</td>
                <td className="num" style={{ fontWeight: 700, color: 'var(--brand-primary)' }}>
                  {r.involvement.toLocaleString()}
                </td>
                <td className="num">{r.modified_male.toLocaleString()}</td>
                <td className="num">{r.modified_female.toLocaleString()}</td>
                <td className="num">{r.junior_male.toLocaleString()}</td>
                <td className="num">{r.junior_female.toLocaleString()}</td>
                <td className="num">{r.senior_male.toLocaleString()}</td>
                <td className="num">{r.senior_female.toLocaleString()}</td>
                <td className="num">{r.schools.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ fontWeight: 700, background: 'rgba(11,61,145,0.04)' }}>
              <td></td>
              <td>TOTAL</td>
              <td className="num" style={{ color: 'var(--brand-primary)' }}>
                {sorted.reduce((s, r) => s + r.involvement, 0).toLocaleString()}
              </td>
              <td className="num">{sorted.reduce((s, r) => s + r.modified_male, 0).toLocaleString()}</td>
              <td className="num">{sorted.reduce((s, r) => s + r.modified_female, 0).toLocaleString()}</td>
              <td className="num">{sorted.reduce((s, r) => s + r.junior_male, 0).toLocaleString()}</td>
              <td className="num">{sorted.reduce((s, r) => s + r.junior_female, 0).toLocaleString()}</td>
              <td className="num">{sorted.reduce((s, r) => s + r.senior_male, 0).toLocaleString()}</td>
              <td className="num">{sorted.reduce((s, r) => s + r.senior_female, 0).toLocaleString()}</td>
              <td className="num">{sorted.reduce((s, r) => s + r.schools, 0).toLocaleString()}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
